import { Info, X } from "lucide-react";
import { PropsWithChildren } from "react";

import { cn } from "@/lib/utils/cn";

type AlertVariant = "error" | "warn" | "info" | "success";

type AlertProps = {
  variant: AlertVariant;
  className?: string;
  onClose?: () => void;
  icon?: React.ReactNode;
};

const variantStyles: Record<AlertVariant, string> = {
  error: "text-destructive bg-destructive/15",
  warn: "text-warning bg-warning/30",
  info: "text-foreground bg-muted/40",
  success: "text-success bg-success/15",
};

export const Alert = ({
  variant,
  className,
  children,
  onClose,
  icon,
}: PropsWithChildren<AlertProps>) => (
  <div
    className={cn(
      "flex items-start gap-2 rounded-lg px-2.5 py-1.5 text-xs font-medium leading-4",
      variantStyles[variant],
      className
    )}
  >
    <span className="mt-0.5 size-4 shrink-0">
      {icon ?? <Info className="size-4" />}
    </span>
    <span className="flex-1 leading-4">{children}</span>
    {onClose && (
      <button
        onClick={onClose}
        className="size-3.5 mt-0.5 transition-opacity cursor-pointer hover:opacity-60"
        aria-label="Close alert"
      >
        <X className="size-3.5" />
      </button>
    )}
  </div>
);
